export default __webpack_public_path__ + "static/media/cacodemon.f1e4eecf.png";